import { ApiClient } from '@/api/ApiClient';

const state = {
  items: [],
  isLoading: false,
  hasNextPage: true,
};

const actions = {
    async fetch({ commit }, options = {}) {
    commit('setLoading', true);
    const response = await ApiClient.recordings.get({ params: options });
    commit('setRecordings', response.data);
    commit('setLoading', false);
  },
};

const mutations = {
  setRecordings(state, recordings) {
    const { data, nextPageUrl } = recordings;
    state.items = data;
    state.hasNextPage = !!nextPageUrl;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
